/** Full-page company detail URL (opens in app router). */
export const getCompanyDetailPath = (companyId: string): string =>
  `/admin/lead-management/companies/${encodeURIComponent(companyId)}`;

/** Open the company detail page in a new browser tab. */
export const openCompanyDetailInNewTab = (companyId: string): void => {
  window.open(getCompanyDetailPath(companyId), '_blank', 'noopener,noreferrer');
};
